// extracted by mini-css-extract-plugin
export default {"Player":"MediaPlayer_Player__B5c+j"};